function mapGameToEvent(eventList) {
  return (eventList || []).map((el) => {
    return {
      id: el.id,
      attributes: {
        when: el.attributes.date,
				team: {data: {attributes: {level: el?.attributes?.team?.data?.attributes?.level}}}, 
        where: el.attributes.location === 'home' ? 'Casa' : 'Fora',
        type: `vs ${el.attributes.opponent}`,
      },
    };
  });
}

module.exports = { mapGameToEvent };
